import React, { Component } from 'react'
import styled from 'styled-components'

import Logic from './logic'
import DataFilters from './data'

import DropdownV2 from '../../components/DropdownV2'
import GhostRadioV2 from '../../components/GhostRadioV2'
import InputV2 from '../../components/InputV2'
import MobileModalV2 from 'components/MobileModalV2'

import IcSearch from './images/search.component.svg'

@Logic
export default class FiltersSectionV2 extends Component {
  componentDidMount() {
    this.scrollerBoxRef.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    const { isMobile } = this.props
    if (!isMobile) {
      this.actions.resetEntities()
      this.actions.setSearchQuery('')
      this.actions.setEntitiesCount(0)
      this.actions.setEntitiesOffset(0)
    }
    this.scrollerBoxRef.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (event) => {
    const { limit, offset, count } = this.props
    const { setEntitiesOffset, fetchEntities } = this.actions
    const { scrollTop, scrollHeight, clientHeight } = event.target

    if (scrollTop + clientHeight >= scrollHeight) {
      if (offset + limit < count) {
        setEntitiesOffset(offset + limit)
        fetchEntities()
      }
    }
  }

  /**
   * Finds the filter section
   */
  findFilterSection = (section) => {
    return DataFilters.find(({ filterSection }) => filterSection === section)
  }

  /**
   * Adds the new filter to the state
   */
  setFilterAndCheckIfFinishFlow = (value, item, section) => {
    const { filters } = this.props
    const newFilters = { ...filters }
    const filterSection = this.findFilterSection(section)

    if (filterSection.type === 'radio' && value && section !== 'tariff_type') {
      filterSection.filters.forEach((filter) => {
        if (filter.fieldName === item.fieldName) {
          newFilters[filter.fieldName] = true
        } else {
          newFilters[filter.fieldName] = false
        }
      })
    } else if (section === 'entities') {
      if (newFilters.entity_designation) {
        const ids = newFilters.entity_designation
        const itemIndex = ids.indexOf(item.id)

        if (itemIndex !== -1) {
          // Remove the item if it already exists
          ids.splice(itemIndex, 1)
          newFilters.entity_designation = ids
        } else {
          // Add the item if it doesn't exist
          newFilters.entity_designation = [
            ...newFilters.entity_designation,
            item.id,
          ]
        }
      } else {
        newFilters.entity_designation = [item.id]
      }
    } else {
      newFilters[item.fieldName] = value
    }

    this.actions.setFilter(newFilters)
    this.props.changePage({ currentPage: 1 })

    // Wait for redux to finsh doing stuff
    setTimeout(() => {
      this.actions.triggerFilter()
    }, 0)
  }

  /**
   * Renders the filters boxes based on the json data
   */
  renderFilters = () => {
    const {
      filters: stateFilters,
      searchedEntitiesOptions,
      entitiesOptions,
      isMobile,
      searchQuery,
      simulation,
    } = this.props
    const { searchEntity } = this.actions

    return (
      DataFilters &&
      DataFilters.map(
        ({
          name,
          hidden,
          type,
          filters,
          filterSection,
          search,
          fillFromApi,
        }) => {
          if (hidden) {
            return null
          }
          if (
            filterSection === 'tariff_type' &&
            (!simulation.results || !simulation.results.electricityPriceList)
          ) {
            return null
          }

          let transformedName = name
          if (type === 'checkbox') {
            let activeFilters = 0

            filters.forEach((filter) => {
              if (stateFilters[filter.fieldName]) {
                activeFilters++
              }
            })

            transformedName = activeFilters
              ? `${name} (${activeFilters})`
              : name
          }

          let filterOptions = filters

          if (fillFromApi && filterSection === 'entities') {
            filterOptions = entitiesOptions
            if (searchQuery) {
              filterOptions = searchedEntitiesOptions
            }
          }

          let searchBox
          if (search && filterSection === 'entities') {
            searchBox = (
              <InputV2
                labelStyle={{ display: 'unset' }}
                style={{ flexGrow: '1' }}
                type='text'
                placeholder='Pesquisar por comercializador'
                icon={<IcSearch />}
                onChange={(val) => searchEntity(val)}
              />
            )
          }

          return (
            <DropdownV2
              style={isMobile ? { width: '100%' } : { maxWidth: '270px' }}
              isOpen={isMobile ? true : type !== 'radio'}
              title={transformedName}
              key={`filter_section_${filterSection}`}>
              <div style={{ width: '100%' }}>
                {searchBox}
                <ScrollerBox
                  fixedHeight={filterSection === 'entities'}
                  innerRef={(ref) => (this.scrollerBoxRef = ref)}>
                  {filterOptions.map((item) => {
                    let selected = stateFilters[item.fieldName]

                    if (filterSection === 'entities') {
                      selected = stateFilters[item.fieldName].includes(item.id)
                    } else if (filterSection === 'tariff_type') {
                      selected = stateFilters[item.fieldName] === item.value
                    }

                    return (
                      <GhostRadioV2
                        key={`input_${type}_${item.fieldName}_${item.label}`}
                        type={type}
                        name={item.fieldName}
                        hasBorder
                        label={item.label}
                        selected={selected}
                        style={{
                          minWidth: '20px',
                        }}
                        onClick={() => {
                          const value =
                            filterSection === 'tariff_type'
                              ? item.value
                              : !stateFilters[item.fieldName]

                          this.setFilterAndCheckIfFinishFlow(
                            value,
                            item,
                            filterSection
                          )
                        }}
                        value={item.value}
                      />
                    )
                  })}
                </ScrollerBox>
              </div>
            </DropdownV2>
          )
        }
      )
    )
  }

  renderContent = () => {
    const { isMobile } = this.props
    const { resetFilters } = this.actions

    return isMobile ? (
      <MobileModalV2
        onClose={this.props.onClose}
        border
        title='Filtros'
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}>
        <MobileWrapper>
          <MobileReset>
            <ResetBtn onClick={resetFilters}>Limpar Filtros</ResetBtn>
          </MobileReset>
          {this.renderFilters()}
        </MobileWrapper>
      </MobileModalV2>
    ) : (
      <Wrapper {...this.props}>
        <TitleRow>
          <h3>Filtros</h3>
          <ResetBtn onClick={resetFilters}>Limpar Filtros</ResetBtn>
        </TitleRow>

        <FiltersWrapper>{this.renderFilters()}</FiltersWrapper>
      </Wrapper>
    )
  }

  /** Lonely boy */
  render() {
    return this.renderContent()
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
`

const MobileWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  flex: 1 0 0;
  padding: 16px 20px;
  overflow-y: auto;
`

const TitleRow = styled.div`
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h3 {
    color: #1d1e22;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 1px;
    margin: 0;
    text-transform: none;
  }
`

const MobileReset = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const ResetBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  border: none;
  outline: none;
  background: transparent;

  cursor: pointer;

  color: #006736;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  &:hover {
    text-decoration: underline;
  }
`

const FiltersWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

const ScrollerBox = styled.div.attrs({ ref: (props) => props.forwardedRef })`
  width: 100%;
  overflow-y: auto;

  ${({ fixedHeight }) =>
    fixedHeight &&
    `
    height: 500px;

    &::-webkit-scrollbar {
      background-color: #fff;
    }

    &::-webkit-scrollbar-button {
      display: none;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 7px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #e1e1e1;
      border-radius: 7px;
      border: 3px solid #fff;
    }

  `}
`



// WEBPACK FOOTER //
// ./src/containers/FiltersSectionV2/index.js